export const textOf = (value: unknown): string =>
  typeof value === 'string' || typeof value === 'number' ? String(value) : '';

/** The columns and rows `import_pasted_rows` sends, as clean text grids. */
export function pastedRowsOf(result: Record<string, unknown>): {
  columns: string[];
  rows: string[][];
} {
  const columns = Array.isArray(result.columns)
    ? result.columns.map(textOf).filter(Boolean)
    : [];
  const rows = Array.isArray(result.rows)
    ? result.rows
        .filter((row): row is unknown[] => Array.isArray(row))
        .map((row) => columns.map((_, index) => textOf(row[index])))
    : [];
  return { columns, rows };
}
